export default "__VITE_ASSET__pjUfdMFp__"